import React from 'react';
import { Sprite } from '@ktag/styleguide/dist/react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import useBacklinkUrl from 'lib/BackButton/useBacklinkUrl';
import { useTranslation } from 'react-i18next';
import useNavPolls from './useNavPolls';

interface Props {
  pollId: string;
  parentId: string;
  small?: boolean;
  backLabel: string;
}

const PollNavigation = ({ pollId, parentId, small, backLabel }: Props) => {
  const { t } = useTranslation('wap');

  const { prevPollLink, nextPollLink, prevPollTitle, nextPollTitle } = useNavPolls(
    pollId,
    parentId,
  );

  const hidePrevNext = !prevPollLink && !nextPollLink;

  const backlinkUrl = useBacklinkUrl(parentId);

  return (
    <nav
      role="navigation"
      className={classNames('pollnavigation', { 'pollnavigation--small': small })}
      aria-label={
        hidePrevNext ? t('aria_label_navigation_hidden') : t('aria_label_navigation')
      }
      aria-hidden={hidePrevNext && small}
    >
      <div
        className={classNames('pollnavigation__prevnext', {
          'pollnavigation__prevnext--hidden': hidePrevNext,
        })}
      >
        {prevPollLink && (
          <Link
            to={prevPollLink}
            className="button pollnavigation__button pollnavigation__button--prev"
            title={small && t('prev_issue_screen_reader_info', { issue: prevPollTitle })}
          >
            <Sprite id="chevron-left" />
            <span className="pollnavigation__label">{prevPollTitle}</span>
          </Link>
        )}
        {nextPollLink && (
          <Link
            to={nextPollLink}
            className="button pollnavigation__button pollnavigation__button--next"
            title={small && t('next_issue_screen_reader_info', { issue: nextPollTitle })}
          >
            <span className="pollnavigation__label">{nextPollTitle}</span>
            <Sprite id="chevron" />
          </Link>
        )}
      </div>
      {backLabel && (
        <Link
          to={backlinkUrl}
          aria-label={t('aria_label_back')}
          className="pollnavigation__back"
        >
          <Sprite id="tiles" />
          {backLabel}
        </Link>
      )}
    </nav>
  );
};

export default PollNavigation;
